var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWildberries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.844 27.5H7.065V11.647h6.625c1.502 0 2.68.355 3.538 1.065.857.704 1.285 1.667 1.285 2.89 0 .835-.27 1.578-.813 2.23-.542.652-1.212 1.04-2.01 1.165v.197c1.069.103 1.937.506 2.604 1.209.666.696 1 1.56 1 2.593 0 1.391-.488 2.49-1.462 3.296-.967.805-2.296 1.208-3.988 1.208zM9.9 13.899v4.416h2.736c1.003 0 1.765-.186 2.285-.56.527-.38.79-.93.79-1.648 0-.696-.237-1.238-.713-1.626-.476-.388-1.143-.582-2-.582H9.9zm0 11.349h3.296c1.047 0 1.842-.209 2.384-.626.542-.425.813-1.04.813-1.846 0-.791-.282-1.392-.846-1.802-.557-.41-1.377-.615-2.461-.615H9.9v4.889zm17.688.208c.96 0 1.703-.329 2.23-.988.535-.66.802-1.59.802-2.79 0-1.15-.267-2.044-.802-2.681-.527-.638-1.27-.956-2.23-.956s-1.707.318-2.241.956c-.528.637-.791 1.53-.791 2.68 0 1.201.263 2.132.79 2.79.528.66 1.275.99 2.242.99zm-3.67-7.35h.187c.813-1.508 2.157-2.263 4.032-2.263 1.59 0 2.868.52 3.834 1.56.967 1.033 1.45 2.44 1.45 4.22 0 1.896-.52 3.39-1.56 4.482-1.032 1.091-2.446 1.637-4.24 1.637-1.883 0-3.333-.605-4.35-1.813-1.012-1.208-1.517-3.003-1.517-5.383 0-3.033.49-5.288 1.472-6.768.99-1.487 2.604-2.274 4.845-2.362l1.417-.055a12.69 12.69 0 0 0 1.616-.165c.527-.095.908-.18 1.142-.252.242-.074.37-.118.385-.132v2.263a2.524 2.524 0 0 1-.286.143c-.124.058-.443.143-.956.252-.505.103-1.084.165-1.736.187l-1.384.055c-.754.03-1.395.143-1.923.34-.52.199-.944.492-1.274.88a4.16 4.16 0 0 0-.758 1.34c-.176.505-.308 1.117-.395 1.835z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22,
    y1: 33,
    x2: 14,
    y2: -2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#FA3C96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildberries);
export default __webpack_public_path__ + "static/media/wildberries.1db851471cf9f0de31b7e90887594912.svg";
export { ForwardRef as ReactComponent };